import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

Vue.use(VueAxios, axios)

const instance = axios.create();

const servicesAPI = {     
  obtenerCuentaContableSettings() {
    var url = ConfigAPI.baseURL + "accounting-settings" + Session.getToken();
    return instance.get(url);
  },
  editarCuentaContableSettings(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "accounting-settings/" + data.id + Session.getToken();
    return instance.post(url,params);
  },

  reporteContable(report, data) {
    var url = ConfigAPI.baseURL + "accounting-reports/" + report + Session.getToken();
    return instance.post(url, data);
  },
  origenAsiento(id) {
    var url = ConfigAPI.baseURL + "accounting/" + id + "/source" + Session.getToken();
    return instance.get(url);
  },
  obtenerEmpresas() {
    var url = ConfigAPI.baseURL + "accounting-business" + Session.getToken();
    return instance.get(url);
  },
  filtrarPlanCuenta(data) {
    var params = data
    var url = ConfigAPI.baseURL + "accounting-accounts/filter/query" + Session.getToken();
    return instance.post(url,params);
  },
  agregarPlanCuenta(data) {    
    var params = data
    var url = ConfigAPI.baseURL + "accounting-accounts" + Session.getToken();
    return instance.post(url,params);
  },
  editarPlanCuenta(data) {    
    var params = data    
    var url = ConfigAPI.baseURL + "accounting-accounts/"+ data.id + Session.getToken();
    return instance.post(url,params);
  },    
  eliminarPlanCuenta(id) {
    var url = ConfigAPI.baseURL + "accounting-accounts/"+ id + Session.getToken();
    return instance.delete(url);
  },     
  cargarPlanEstandar() {
    var url = ConfigAPI.baseURL + "accounting-accounts/load/standard" + Session.getToken();
    return instance.post(url);
  },
  importarPlanCuenta(data, file) {    
    var headers = {
      'Content-Type': 'multipart/form-data'
    }
  
    var formData = new FormData();
    data = JSON.parse(data)
    for ( var key in  data) {
      if(key!="file") {
        formData.append(key, data[key]);
      }

      if(key=="file") {                
        file.forEach((value) => {          
          formData.append('file', value);
        })
      }      
    }

    var params = formData
    var url = ConfigAPI.baseURL + "accounting-accounts/import/CSV" + Session.getToken();
    
    return instance.post(url,params,{headers});
  },

  agregarAsiento(data) {    
    var params = data
    var url = ConfigAPI.baseURL + "accounting" + Session.getToken();
    return instance.post(url,params);
  },
  editarAsiento(data) {    
    var params = data
    var url = ConfigAPI.baseURL + "accounting/" + data.id + Session.getToken();
    return instance.post(url,params);
  },
  eliminarAsiento(id) {
    var url = ConfigAPI.baseURL + "accounting/" + id + Session.getToken();
    return instance.delete(url);
  },
  mayorCuentas(data) {
    var params = data
    var url = ConfigAPI.baseURL + "accounting/report/account-ledger" + Session.getToken();
    return instance.post(url,params);
  },
     
  
  filtrarAsientos(data, page) {
    var params = data
    var url = ConfigAPI.baseURL + "accounting/filter/query" + Session.getToken() + "&page=" + page;
    return instance.post(url,params);
  },

  obtenerInicioControl() {
    var url = ConfigAPI.baseURL + "accounting-automatic/starts" + Session.getToken();
    return instance.get(url);
  },
  filtrarAsientosPendientes(data, page) {
    var url = ConfigAPI.baseURL + "accounting-automatic/pending" + Session.getToken() + "&page=" + page;
    return instance.post(url, Object.assign({}, data, { page: page }));
  },
  obtenerClavesPendientes(data) {
    var url = ConfigAPI.baseURL + "accounting-automatic/pending/keys" + Session.getToken();
    return instance.post(url, data);
  },
  generarAsientos(data) {
    var url = ConfigAPI.baseURL + "accounting-automatic/generate" + Session.getToken();
    return instance.post(url, data);
  },

  obtenerFechasCierre(data) {
    var params = data || {}
    var url = ConfigAPI.baseURL + "accounting/closing/dates" + Session.getToken();
    return instance.post(url, params);
  },

  previewCierreApertura(data) {
    var params = data
    var url = ConfigAPI.baseURL + "accounting/closing/preview" + Session.getToken();
    return instance.post(url, params);
  },
  generarCierre(data) {
    var params = data
    var url = ConfigAPI.baseURL + "accounting/closing/generate-closing" + Session.getToken();
    return instance.post(url, params);
  },
  borrarAsientoAprobado(id) {
    var url = ConfigAPI.baseURL + "accounting-automatic/revert/" + id + Session.getToken();
    return instance.post(url, {});
  },
  obtenerEstadoPeriodo(data) {
    var params = data
    var url = ConfigAPI.baseURL + "accounting/closing/status" + Session.getToken();
    return instance.post(url, params);
  },
  bloquearMes(data) {
    var params = data
    var url = ConfigAPI.baseURL + "accounting/closing/lock-month" + Session.getToken();
    return instance.post(url, params);
  },
  desbloquearMes(data) {
    var params = data
    var url = ConfigAPI.baseURL + "accounting/closing/unlock-month" + Session.getToken();
    return instance.post(url, params);
  },
  reabrirPeriodo(data) {
    var params = data
    var url = ConfigAPI.baseURL + "accounting/closing/reopen" + Session.getToken();
    return instance.post(url, params);
  },
  generarApertura(data) {
    var params = data
    var url = ConfigAPI.baseURL + "accounting/closing/generate-opening" + Session.getToken();
    return instance.post(url, params);
  },
}

export default servicesAPI;
